import * as React from "react";
import { forwardRef, memo } from "react";
const SvgOutlinedRightArrowIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.46973 19.0305L15.5303 12.0305L8.46973 5.03052", stroke: "#333333", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgOutlinedRightArrowIcon);
const Memo = memo(ForwardRef);
export default Memo;
